import {Component} from '@angular/core';
import {environment} from "../../../../../environments/environment";

@Component({
  templateUrl: '403.component.html',
  styleUrls: ['./403.component.scss'],
  standalone: true
})
export class P403Component {

  constructor() {
  }

  protected readonly environment = environment;
}
